// extracted by mini-css-extract-plugin
var _1 = "fjp4A";
var _2 = "Apj0h";
var _3 = "LRHwK";
var _4 = "ZjwRQ";
var _5 = "WOJWu";
var _6 = "F9HX_";
var _7 = "T5d8O";
var _8 = "vV7gG";
var _9 = "NnyDT";
var _a = "raeLQ";
var _b = "jMnqh";
var _c = "BU8U4";
var _d = "xiqKq";
var _e = "qunn5";
var _f = "VM3c4";
export { _1 as "is-aqua", _2 as "is-dark", _3 as "is-darkest", _4 as "is-gold", _5 as "is-light", _6 as "is-lightest", _7 as "is-medium", _8 as "is-mint", _9 as "is-neutral", _a as "is-normal", _b as "is-ruby", _c as "is-small", _d as "is-teal", _e as "is-violet", _f as "loading-spinner" }
